import { render, staticRenderFns } from "./CheckoutButtonCheckoutConfirm.vue?vue&type=template&id=2221dcc5&"
import script from "./CheckoutButtonCheckoutConfirm.vue?vue&type=script&lang=js&"
export * from "./CheckoutButtonCheckoutConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports